import _toConsumableArray from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as log from '../log';
import { keys } from '../util';
import { CompositeMarkNormalizer } from './base';
import { makeCompositeAggregatePartFactory } from './common';
import { errorBarParams } from './errorbar';
export var ERRORBAND = 'errorband';
var ERRORBAND_PART_INDEX = {
  band: 1,
  borders: 1
};
export var ERRORBAND_PARTS = keys(ERRORBAND_PART_INDEX);
export var errorBandNormalizer = new CompositeMarkNormalizer(ERRORBAND, normalizeErrorBand);
export function normalizeErrorBand(spec, _ref) {
  var config = _ref.config;

  var _errorBarParams = errorBarParams(spec, ERRORBAND, config),
      transform = _errorBarParams.transform,
      continuousAxisChannelDef = _errorBarParams.continuousAxisChannelDef,
      continuousAxis = _errorBarParams.continuousAxis,
      encodingWithoutContinuousAxis = _errorBarParams.encodingWithoutContinuousAxis,
      markDef = _errorBarParams.markDef,
      outerSpec = _errorBarParams.outerSpec,
      tooltipEncoding = _errorBarParams.tooltipEncoding;

  var errorBandDef = markDef;
  var makeErrorBandPart = makeCompositeAggregatePartFactory(errorBandDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorband);
  var is2D = spec.encoding.x !== undefined && spec.encoding.y !== undefined;
  var bandMark = {
    type: is2D ? 'area' : 'rect'
  };
  var bordersMark = {
    type: is2D ? 'line' : 'rule'
  };
  var interpolate = Object.assign({}, errorBandDef.interpolate ? {
    interpolate: errorBandDef.interpolate
  } : {}, errorBandDef.tension && errorBandDef.interpolate ? {
    interpolate: errorBandDef.tension
  } : {});

  if (is2D) {
    bandMark = Object.assign({}, bandMark, interpolate);
    bordersMark = Object.assign({}, bordersMark, interpolate);
  } else if (errorBandDef.interpolate) {
    log.warn(log.message.errorBand1DNotSupport('interpolate'));
  } else if (errorBandDef.tension) {
    log.warn(log.message.errorBand1DNotSupport('tension'));
  }

  return Object.assign({}, outerSpec, {
    transform: transform,
    layer: [].concat(_toConsumableArray(makeErrorBandPart({
      partName: 'band',
      mark: bandMark,
      positionPrefix: 'lower',
      endPositionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBandPart({
      partName: 'borders',
      mark: bordersMark,
      positionPrefix: 'lower',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBandPart({
      partName: 'borders',
      mark: bordersMark,
      positionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })))
  });
}